// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"9afd39cddde44ad3","9741":"4ecf317cf4f9a6ed"}[chunkId] + ".css";
};